import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { SetupService } from 'src/app/physician/setup/setup.service';



export abstract class CaseManagerBaseLayout implements OnInit {
  role: string;
  showSidebar: boolean = true;
  profilelist = true;
  photoUrlsend: string;
  sideNavOpened = true;
  hasAccess: boolean = false;
  sidebar = {
    referralsCollapsed: false,
    settingsCollapsed: false,
  };
  isAdmin: boolean = false;
  isAHIAdmin: boolean = false;
  isImpersonating: boolean = false;
  expandNav = false;
  showPhysicianSelector = true;

  constructor(private _practiceService: PracticeService, private _userService: UserService, private _router: Router,
    private _setupService: SetupService) {
  }

  ngOnInit(): void {

    this.LoadStatus();

    this._setupService.isSetupCompleted$.subscribe(
      (_) => {
        this._userService.clearGetUserDetailsCache();

        this.LoadStatus();
      },
      (error) => { console.error(error); }
    );


  }

  private LoadStatus() {
    this._userService.getUserDetails().subscribe(
      (user) => {
        this._practiceService.setCurrentUser(user);
        this.isImpersonating = user.isImpersonating;
        this.isAHIAdmin = this._practiceService.checkForAHI();
        this.isAdmin = this._practiceService.checkForAdmin();

        if (this._practiceService.shouldRedirectToSetupFlow()) {
          this._router.navigate(['/casemanager/profile/setupOrganization']);
        } else if (!this._practiceService.isCurrentUserActive() || !this._practiceService.isCurrentHOAccessActive()) {
          this._router.navigate(['/inactive']);
        }
      },
      (error) => { console.error(error); }
    );
  }

  showLeftMenu(): boolean {
    return this._practiceService.isCurrentHOAccessActive();
  }

  openProfileList() {
    this.profilelist = false;
  }

  expandSidebar(event) {
    if (event.type === 'mouseover') {
      this.expandNav = true;
    } else {
      this.expandNav = false;
    }
  }

}
